import { Stack } from 'component-library';
import { useTranslation } from 'react-i18next';

import { SpeciesGroupId } from '@/api/rest/resources/conservation';
import { ChartHeading } from '@/components/Charts/components/ChartHeading';
import {
  SpeciesChangeChartData,
  SpeciesOccupancyHistoricalChart,
} from '@/pages/shared/projects/pages/project/pages/conservation/BU/components/Charts/SpeciesOccupancyHistorical';
import { useProject } from '@/pages/shared/projects/pages/project/pages/conservation/shared/hooks/useProject';

export type SpeciesOccupancyData = Record<SpeciesGroupId, Record<string, number>>;

export const GraphTile = ({ data }: { data: SpeciesOccupancyData }) => {
  const { t } = useTranslation();

  const project = useProject();

  const chartData = Object.entries(data ?? {}).map(([speciesGroup, value]) => {
    const speciesGroupLabel = project?.speciesGroups?.[speciesGroup as SpeciesGroupId] ?? speciesGroup;

    return {
      group: speciesGroupLabel,
      ...value,
    };
  }) as SpeciesChangeChartData[];

  return (
    <Stack center spacing={6} data-testid='species-occupancy-graph-tile'>
      <ChartHeading
        heading={t('shared.ncaDetail.indicatorSpecies.occupancy.chartHeading')}
        className='w-full px-6 sm:px-0'
      />
      <SpeciesOccupancyHistoricalChart data={chartData} />
    </Stack>
  );
};
